var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 45,
    viewBox: "0 0 32 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 44L4.75 40.2609L8.5 44L12.25 40.2609L16 44L19.75 40.2609L23.5 44L27.25 40.2609L31 44V1L27.25 4.73913L23.5 1L19.75 4.73913L16 1L12.25 4.73913L8.5 1L4.75 4.73913L1 1V44V44Z",
    stroke: "#217A73",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.625 12.2188H21.625",
    stroke: "#217A73",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.625 17.8242H14.125",
    stroke: "#217A73",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.625 23.4375H14.125",
    stroke: "#217A73",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.625 29.043H12.25",
    stroke: "#217A73",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1201 25.3845C19.1201 24.8852 19.5249 24.4805 20.0241 24.4805H21.8721C21.9841 24.4805 22.1281 24.4858 22.3041 24.4965C22.4855 24.5018 22.6508 24.5178 22.8001 24.5445C23.4615 24.6458 24.0081 24.8698 24.4401 25.2165C24.8775 25.5578 25.2001 25.9871 25.4081 26.5045C25.6215 27.0218 25.7281 27.5978 25.7281 28.2325C25.7281 29.1605 25.5068 29.9471 25.0641 30.5925C24.6268 31.2325 23.9575 31.6565 23.0561 31.8645C22.8375 31.9125 22.6455 31.9445 22.4801 31.9605C22.3148 31.9711 22.1095 31.9765 21.8641 31.9765H19.1201V31.1765C19.1201 30.6242 19.5678 30.1765 20.1201 30.1765H21.7921C21.9041 30.1765 22.0241 30.1711 22.1521 30.1605C22.2855 30.1498 22.4108 30.1285 22.5281 30.0965C22.8428 30.0111 23.0908 29.8698 23.2721 29.6725C23.4588 29.4698 23.5895 29.2405 23.6641 28.9845C23.7441 28.7285 23.7841 28.4778 23.7841 28.2325C23.7841 27.9871 23.7441 27.7365 23.6641 27.4805C23.5895 27.2191 23.4588 26.9871 23.2721 26.7845C23.0908 26.5818 22.8428 26.4405 22.5281 26.3605C22.4108 26.3285 22.2855 26.3098 22.1521 26.3045C22.0241 26.2938 21.9041 26.2885 21.7921 26.2885H20.0241C19.5249 26.2885 19.1201 25.8837 19.1201 25.3845ZM19.1201 31.9765L20.714 31.6114C21.0291 31.5393 21.3596 31.6239 21.6013 31.8385L24.5336 34.4424C25.1467 34.9869 24.7616 36.0005 23.9417 36.0005C23.7218 36.0005 23.5096 35.9192 23.346 35.7722L19.1201 31.9765ZM19.9041 28.9605C19.5021 28.9605 19.1761 28.6345 19.1761 28.2325C19.1761 27.8304 19.5021 27.5045 19.9041 27.5045H26.3601C26.7622 27.5045 27.0881 27.8304 27.0881 28.2325C27.0881 28.6345 26.7622 28.9605 26.3601 28.9605H19.9041ZM22.3601 25.9365C21.9581 25.9365 21.6321 25.6105 21.6321 25.2085C21.6321 24.8064 21.9581 24.4805 22.3601 24.4805H26.3121C26.7142 24.4805 27.0401 24.8064 27.0401 25.2085C27.0401 25.6105 26.7142 25.9365 26.3121 25.9365H22.3601Z",
    fill: "#217A73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteIcon);
export default __webpack_public_path__ + "static/media/noteIcon.1cbd853c8a1cdef84b062beb5371d6cb.svg";
export { ForwardRef as ReactComponent };